import React from "react";

import { LoadingIcon } from "@packages/ds";
import { FormattedMessage, useIntl } from "react-intl";

import config from "console_config";
import Button, { Link } from "ds/Button";

import ChartInfo from "../ChartInfo";
import { FlexWrapper } from "../style";

import ServiceItemTitle from "./ServiceItemTitle";
import * as S from "./style";

import type { DeploymentService } from "@packages/client";
import type { ReturnAddClass } from "Reducers/environment/deployment";

const getTroubleMessage = (
  supported?: boolean,
  service?: DeploymentService
) => {
  const noSupportMessages = {
    message: "profiling_not_supported",
    infoTitle: "service_not_supported",
    infoDescription: "service_not_supported_description",
    link: {
      message: "view_documentation",
      href: "link.application_metrics_increase_observability"
    }
  };

  const noData = {
    message: "profiling_not_enabled",
    infoTitle: "enable_continuous_profiling",
    infoDescription: "profiling_enable_info_description",
    link: {
      message: "view_documentation",
      href: "link.application_metrics_increase_observability"
    }
  };
  if (
    !supported &&
    config.CUSTOM_PROFILING_LANGUAGE?.some?.(
      lang => service?.type?.toLowerCase().indexOf(lang) != -1
    )
  )
    return noData;

  return noSupportMessages;
};

type ServiceItemProps = {
  service: ReturnAddClass[string];
  isInstrumented?: boolean;
  isLoading?: boolean;
  onViewApp: (event) => void;
};

const ServiceItem = ({
  service,
  isInstrumented,
  isLoading,
  onViewApp
}: ServiceItemProps) => {
  const intl = useIntl();

  const isSupportedLanguage = config.CUSTOM_PROFILING_LANGUAGE?.some?.(
    lang => service?.type?.toLowerCase().indexOf(lang) != -1
  );

  const troubleMessage = getTroubleMessage(isInstrumented, service);

  return (
    <S.ServiceItem>
      <ServiceItemTitle service={service} />
      {isLoading ? (
        <LoadingIcon />
      ) : (
        <S.Actions>
          {isSupportedLanguage ? (
            <FlexWrapper>
              <FlexWrapper>
                <Button
                  variant="link"
                  onClick={onViewApp}
                  analyticId="view_profiling"
                >
                  <FormattedMessage id="view_profiling" />
                </Button>
              </FlexWrapper>
            </FlexWrapper>
          ) : (
            <FlexWrapper>
              <S.Toggle
                disabled={!isInstrumented}
                variant="link"
                analyticId={troubleMessage.message}
              >
                <FormattedMessage id={troubleMessage.message} />
              </S.Toggle>
              <ChartInfo
                align="end"
                description={intl.formatMessage({
                  id: troubleMessage.infoDescription
                })}
                title={intl.formatMessage({ id: troubleMessage.infoTitle })}
                link={
                  <Link
                    analyticId={troubleMessage.link.message}
                    href={intl.formatMessage({ id: troubleMessage.link.href })}
                  >
                    {intl.formatMessage({ id: troubleMessage.link.message })}
                  </Link>
                }
              />
            </FlexWrapper>
          )}
        </S.Actions>
      )}
    </S.ServiceItem>
  );
};
export default ServiceItem;
